import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; // Assuming you are using React Router for routing
import axios from 'axios'; // Import axios
import "./BusinessForgotPassword.css"
import Navbar from './Navbar';

const BusinessForgotPassword = () => {
    // Declare state for email input and message
    const [businessForgotPasswordData, setBusinessForgotPasswordData] = useState({
        email: '',
    });
    const [message, setMessage] = useState('');

    // Handle input change for email
    const handleBusinessForgotPasswordInputChange = (e) => {
        setBusinessForgotPasswordData({
            ...businessForgotPasswordData,
            [e.target.name]: e.target.value,
        });
    };

    // Handle form submission for forgot password
    const handleBusinessForgotPasswordSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/business/forgot-password`, {
                email: businessForgotPasswordData.email,
            });
            setMessage(response.data.message); // Show success message
        } catch (error) {
            setMessage(error.response?.data?.message || 'Došlo k chybě'); // Show error message, if available
        }
    };
      useEffect(() => {
        const scrollToTop = () => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        scrollToTop()
      }, [])

    return (<div>
            <Navbar />
        <div className="business-forgot-password-container">
            <h2 className="business-forgot-password-title">Zapomenuté heslo</h2>
            <form className="business-forgot-password-form" onSubmit={handleBusinessForgotPasswordSubmit}>
                <input
                    type="email"
                    placeholder="Zadejte firemní email"
                    name="email"
                    value={businessForgotPasswordData.email}
                    onChange={handleBusinessForgotPasswordInputChange}
                    required
                    className="business-forgot-password-input"
                />
                <button type="submit" className="business-forgot-password-button">Odeslat</button>
            </form>

            {/* Links below the button */}
            <div className="business-forgot-password-links">
                <Link to="/business/login" className="business-forgot-password-link">Zpět na přihlášení</Link>
            </div>

            {/* Display success/error message */}
            {message && <p className="business-forgot-password-message">{message}</p>}
        </div>
        </div>
    );
};

export default BusinessForgotPassword;